<template>
	<v-app :class="{ 'main-page': is_desktop_screen }">
		<v-main>
			<v-overlay opacity="0.5" :value="generatingOferta" z-index="100">
				<v-progress-circular indeterminate :size="70" :width="7" color="white"></v-progress-circular>
			</v-overlay>
			<v-snackbar v-model="email_success" class="" top :timeout="1000" color="green">
				<span v-if="country == 'hu'" class="font-weight-bold">Az ajánlat elküldve!</span>
				<span v-else-if="country == 'de' || country == 'at'" class="font-weight-bold">Angebot gesendet!</span>
				<span v-else-if="country == 'fr' || country == 'be'" class="font-weight-bold">Offre envoyée!</span>
				<span v-else class="font-weight-bold">Oferta trimisa!</span>
			</v-snackbar>
			<v-snackbar v-model="email_error" class="" top :timeout="1000" color="red">
				<span v-if="country == 'hu'" class="font-weight-bold">Hiba! Az ajánlat nem elküldve.</span>
				<span v-else-if="country == 'de' || country == 'at'" class="font-weight-bold">Fehler! Das Angebot wurde
					nicht gesendet.</span>
				<span v-else-if="country == 'fr' || country == 'be'" class="font-weight-bold">Erreur! L'offre n'a pas
					été envoyée.</span>
				<span v-else class="font-weight-bold">Eroare! Oferta nu a fost trimisa.</span>
			</v-snackbar>
			<!-- mobile Header -->
			<v-app-bar v-if="is_mobile_screen" class="d-flex align-center justify-start" dense shrink-on-scroll flat
				color="#f2f4f8">
				<v-img width="160" height="40" class="ml-3 align-self-center" :contain="true"
					:src="require('./assets/img/' + logo_filename)"></v-img>
				<v-divider class="mx-4" role="presentation" inset vertical></v-divider>
				<h2 class="mt-2 pa-3 title grey--text align-self-center" style="line-height: 1.2;">
					{{ language.general.title }}
				</h2>
			</v-app-bar>
			<!-- desktop Header -->
			<v-app-bar v-else class="d-flex align-center justify-space-between" flat fixed color="#f2f4f8">
				<v-img width="270" height="90%" class="ml-3 mr-4 flex-grow-0" :contain="true"
					:src="require('./assets/img/' + logo_filename)"></v-img>
				<v-divider class="mx-4 my-2" role="presentation" inset vertical></v-divider>
				<v-stepper v-model="currentStep" class="elevation-0 transparent">
					<v-stepper-header class="elevation-0">
						<v-stepper-step :complete="currentStep > 1" step="1" class="mr-md-4">
							{{ language.general.steps.one }}
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="currentStep > 2" step="2" class="mr-md-4">
							{{ language.general.steps.two }}
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="currentStep > 3" step="3" class="mr-md-4">
							{{ language.general.steps.three }}
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="currentStep > 4" step="4" class="mr-md-4">
							{{ language.general.steps.four }}
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="currentStep > 5" step="5" class="mr-md-4">
							{{ language.general.steps.five }}
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="completed" step="6" class="mr-md-4">
							{{ language.general.steps.six }}
						</v-stepper-step>
					</v-stepper-header>
				</v-stepper>
			</v-app-bar>

			<v-stepper id="scrollTop" v-model="currentStep" class="elevation-0"
				:class="is_mobile_screen ? 'mobile-bottom' : ''">
				<v-stepper-header v-if="is_mobile_screen" class="elevation-0">
					<v-stepper-step :complete="currentStep > 1" step="1">
						{{ language.general.steps.one }}
					</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="currentStep > 2" step="2">
						{{ language.general.steps.two }}
					</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="currentStep > 3" step="3">
						{{ language.general.steps.three }}
					</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="currentStep > 4" step="4">
						{{ language.general.steps.four }}
					</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="currentStep > 5" step="5">
						{{ language.general.steps.five }}
					</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="completed" step="6">
						{{ language.general.steps.six }}
					</v-stepper-step>
				</v-stepper-header>

				<v-btn v-if="is_mobile_screen && currentStep > 1" text large class="mb-sm-0"
					@click="changeStep('prev')">
					<v-icon class="mr-1">mdi-arrow-left</v-icon>
					<span>{{ language.general.buttons.previous }}</span>
				</v-btn>

				<v-stepper-items :class="{ 'mt-6 pt-6': is_tablet_screen }">
					<v-stepper-content step="1">
						<Model class="pt-6" :language="language" :is_mobile_screen="is_mobile_screen"
							@changeModel="loadModel" />
					</v-stepper-content>
					<v-stepper-content step="2">
						<Dimensions class="pt-6" :language="language" :is_mobile_screen="is_mobile_screen"
							:is_tablet_screen="is_tablet_screen" :model="model" @changeDims="loadDims" />
					</v-stepper-content>
					<v-stepper-content step="3">
						<Configuration class="pt-6" ref="config" :language="language"
							:is_mobile_screen="is_mobile_screen" :is_tablet_screen="is_tablet_screen"
							:is_desktop_screen="is_desktop_screen" :model="model" :dimensions="dimensions"
							:lStalp="lStalp" :lPanou="lPanou" @changeConfig="loadConfig"
							@validConfig="loadValidConfig" />
					</v-stepper-content>
					<v-stepper-content step="4">
						<Color class="pt-6" :language="language" :colors="colors" :img="img"
							:is_mobile_screen="is_mobile_screen" :is_tablet_screen="is_tablet_screen"
							@changeColor="loadColor" />
					</v-stepper-content>
					<v-stepper-content step="5">
						<Panel class="pt-6" ref="panel" :language="language" :profile="profile" :selectedColor="color"
							:model="model" :dimensions="dimensions" :configuration="configuration" :lPanou="lPanou"
							:hPanou="hPanou" :defaultProfil="defaultProfil" :key="componentKey"
							:is_mobile_screen="is_mobile_screen" @changePanel="loadPanel" />
					</v-stepper-content>
					<v-stepper-content step="6">
						<Oferta ref="comandaComponent" :language="language" :model="model" :selectedColor="color"
							:dimensions="dimensions" :configuration="configuration" :suprafataPanouri="suprafataPanouri"
							:suprafataPP="suprafataPP" :suprafataPPIncluded="suprafataPPIncluded"
							:suprafataPA="suprafataPA" :suprafata="suprafata" :panel="panel" :img="img"
							:country="country" :judete="judete" :alert="alert" :completed="completed"
							:generatingOferta="generatingOferta" :sendingOferta="sendingOferta"
							:is_mobile_screen="is_mobile_screen" :is_tablet_screen="is_tablet_screen"
							:completedBricksOffer="completedBricksOffer" :completedCallback="completedCallback"
							@bricksSelected="updateBricksOfferSelected" @downloadBricksOffer="downloadBricksOffer"
							@formValid="loadFormValid" @formValidCallback="loadFormValidCallback"
							@clientData="loadClientData" @downloadOferta="downloadOferta" @saveCallback="saveCallback"
							@sendOferta="sendOferta" />
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
			<v-fade-transition>
				<v-footer v-if="!is_mobile_screen || scrolledToBottom" transition="scale-transition" fixed
					class="blue-grey darken-4 white--text px-4 py-4">
					<v-row>
						<v-col v-if="!is_mobile_screen" cols="12" sm="6" md="6"
							class="d-flex align-center justify-start pl-6 py-0">
							<h2 class="title grey--text">
								{{ language.general.title }}
							</h2>
						</v-col>
						<v-col cols="12" sm="6" md="6" class="d-flex align-center justify-center pr-12 py-0">
							<v-col cols="2" sm="6" md="6" class="py-1">
								<v-btn v-if="!is_mobile_screen && currentStep > 1" text block large
									class="white--text mb-sm-0" @click="changeStep('prev')">
									<v-icon class="mr-1">mdi-arrow-left</v-icon>
									<span>{{ language.general.buttons.previous }}</span>
								</v-btn>
							</v-col>
							<v-col cols="12" sm="6" md="6" class="py-md-1">
								<v-btn v-if="currentStep < 6" block large :disabled="!validConfig" color="primary"
									@click="changeStep('next')">
									<span>{{ language.general.buttons.next }}</span>
									<v-icon class="ml-2">mdi-arrow-right</v-icon>
								</v-btn>
								<v-btn v-else-if="!completed" block large color="primary" @click="requestOferta()">
									<span>{{ language.general.buttons.offer }}</span>
									<v-icon class="ml-2">mdi-arrow-right</v-icon>
								</v-btn>
							</v-col>
						</v-col>
					</v-row>
				</v-footer>
			</v-fade-transition>
		</v-main>
		<!-- <pre>{{ prices }}</pre> -->
		<!-- <pre>{{ pretTotal }}</pre>
		<pre>{{
			suprafataPanouri +
				" | " +
				(Number(suprafataPP) + Number(suprafataPPIncluded)) +
				" | " +
				suprafataPA +
				" | " +
				suprafataPAAP
		}}</pre>
		<pre>Currency: {{ curr_huf }}</pre>
		<pre>Valid: {{ validOfertaForm }}</pre> -->
		<!-- <pre>{{ hPanou }} {{ lPanou }}</pre> -->
		<!-- <pre>{{ img }}</pre> -->
		<!-- <pre>{{ poarta_aap_buc }}</pre> -->
		<!-- <pre>{{ suprafataBricks }}</pre> -->
		<!-- <pre>{{ nrStalpi }}</pre> -->
		<!-- <pre>{{ configuration }}</pre> -->
	</v-app>
</template>

<script>
import datas from "./data/data.js";
import bricksData from "./data/bricksData.js";
import languages from "./data/languages.js";
import moment from "moment";
import axios from "axios";
import * as jsPDF from "jspdf";
import fonts from "./assets/fonts/fonts.js";
import { carport_ad } from "./pdf_functions/carport_aluminiu.js";
import { mag_pubele_ad } from "./pdf_functions/magazii_pubele.js";

import Model from "./components/Model";
import Color from "./components/Color";
import Dimensions from "./components/Dimensions";
import Configuration from "./components/Configuration";
import Panel from "./components/Panel";
import Oferta from "./components/Oferta";
// import OfertaPret from "./components/OfertaPret";

export default {
	name: "App",
	components: {
		Model,
		Color,
		Dimensions,
		Configuration,
		Panel,
		Oferta,
		// OfertaPret
	},
	data: function () {
		return {
			// 'ro' 'hu' 'de' 'at'
			country: process.env.VUE_APP_LANG,
			utmParams: {},
			partener_version: false,
			today: moment(),
			generatingOferta: false,
			sendingOferta: false,
			steps: 6,
			currentStep: 1,
			completed: false,
			scrolledToBottom: false,
			scrollTarget: "#scrollTop",
			scrollOptions: {
				duration: 300,
				offset: 0,
				easing: "easeInOutCubic",
			},
			model: "horizontal",
			defaultProfil: 100,
			componentKey: 0,
			color: {
				name: "RAL 7042",
				hex: "rgb(142, 146, 145)",
			},
			lStalp: 300,
			extraWidthSlidingGate: 500,
			dimensions: {
				lt: 20,
				ht: 1.9,
				hp: 0.9,
			},
			suprafata_limita_panou: 0.1, //ro
			// suprafata_limita_panou: 1.5, //hu
			suprafata_limita_pp: 1.9, //ro
			// suprafata_limita_pp: 1.8, //hu
			suprafata_limita_pa: 6.7,
			suprafata_limita_pa_pp_included: 4.8,
			configuration: {
				panouri: {
					is: true,
					panelFrame: false,
					buc: 7,
				},
				poarta_p: {
					is: true,
					buc: 1,
					items: [
						{
							latime_gol: 1000,
						},
					],
				},
				poarta_a: {
					is: true,
					buc: 1,
					items: [
						{
							latime_gol: 3500,
							tip: "batanta",
							automation: false,
						},
					],
				},
			},
			validConfig: false,
			validOfertaForm: false,
			validCallbackForm: false,
			img: "horizontal_4_1_1.png",
			panel: {},
			// Empty object for client in production
			client: {
				surname: "",
				name: "",
				email: "",
				phone: "",
				judet: "",
				timeframe: "",
				message: "",
				newsletter: false
			},
			colors: datas.colors,
			profile: datas.profile,
			alert: {
				status: false,
				type: "info",
				text: "",
			},
			nrOferta: null,
			email_success: false,
			email_error: false,
			pdfDoc: "",
			pdfBricksDoc: "",
			curr_huf: 365,
			showContact: false,
			bricksOfferSelected: null,
			completedBricksOffer: false,
			noBricksOffer: null,
			completedCallback: false,
			prices: []
		};
	},
	computed: {
		logo_filename() {
			return this.country == "ro"
				? "logo_istruct_cuprolli.svg" : "logo_istruct.svg";
		},
		language() {
			// change before compile to another language
			// return languages.ro;
			return languages[this.country];
		},
		judete() {
			let regions;
			if (this.country == "ro") {
				regions = datas.judete;
			} else if (this.country == "hu") {
				regions = datas.regionsHU;
			} else if (this.country == "de") {
				regions = datas.regionsDE;
			} else if (this.country == "at") {
				regions = datas.regionsAT;
			} else if (this.country == "fr") {
				regions = datas.regionsFR;
			} else if (this.country == "be") {
				regions = datas.regionsBE;
			}
			return regions;
		},
		is_mobile_screen() {
			return this.$vuetify.breakpoint.xsOnly;
		},
		is_tablet_screen() {
			return this.$vuetify.breakpoint.smOnly;
		},
		is_desktop_screen() {
			return this.$vuetify.breakpoint.mdAndUp;
		},
		modelText() {
			let str;
			if (this.model == "horizontal") {
				if (this.country == "ro") {
					str = "orizontal";
				} else if (this.country == "hu") {
					str = "vízszintes";
				} else if (this.country == "de" || this.country == "at") {
					str = "horizontales";
				} else if (this.country == "fr" || this.country == "be") {
					str = "horizontal";
				}
			} else if (this.model == "vertical") {
				if (this.country == "ro") {
					str = "vertical";
				} else if (this.country == "hu") {
					str = "függőleges";
				} else if (this.country == "de" || this.country == "at") {
					str = "vertikales";
				} else if (this.country == "fr" || this.country == "be") {
					str = "vertical";
				}
			}
			return str;
		},
		golText() {
			let str;
			if (this.panel.selectedGapSize == "small") {
				if (this.country == "ro") {
					str = "mica";
				} else if (this.country == "hu") {
					str = "kicsi";
				} else if (this.country == "de" || this.country == "at") {
					str = "kleine";
				} else if (this.country == "fr" || this.country == "be") {
					str = "minimal";
				}
			} else if (this.panel.selectedGapSize == "medium") {
				if (this.country == "ro") {
					str = "medie";
				} else if (this.country == "hu") {
					str = "közepes";
				} else if (this.country == "de" || this.country == "at") {
					str = "mittelere";
				} else if (this.country == "fr" || this.country == "be") {
					str = "moyen";
				}
			} else {
				if (this.country == "ro") {
					str = "mare";
				} else if (this.country == "hu") {
					str = "nagy";
				} else if (this.country == "de" || this.country == "at") {
					str = "große";
				} else if (this.country == "fr" || this.country == "be") {
					str = "large";
				}
			}
			return str;
		},
		poarta_ab_buc() {
			let count = 0;
			this.configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "batanta") {
					count++;
				}
			});
			return count;
		},
		poarta_ac_buc() {
			let count = 0;
			this.configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "culisanta") {
					count++;
				}
			});
			return count;
		},
		poarta_aap_buc() {
			let count = 0;
			this.configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "autoportanta") {
					count++;
				}
			});
			return count;
		},
		hasPPIncluded() {
			let count = false;
			this.configuration.poarta_a.items.forEach((item) => {
				if (item.pp_included) {
					count = true;
					return;
				}
			});
			return count;
		},
		hPanou() {
			return (this.dimensions.ht - this.dimensions.hp).toFixed(2);
		},
		lPanou() {
			if (this.dimensions.lt > 6) {
				let l_totala = Number(this.dimensions.lt) * 1000 - this.lStalp;
				if (this.configuration.poarta_p.is) {
					let l_portiP = 0;
					this.configuration.poarta_p.items.forEach((poarta) => {
						l_portiP = l_portiP + (Number(poarta.latime_gol) + this.lStalp);
					});
					l_totala = l_totala - l_portiP;
				}
				if (this.configuration.poarta_a.is) {
					let l_portiA = 0;
					this.configuration.poarta_a.items.forEach((poarta) => {
						l_portiA = l_portiA + (Number(poarta.latime_gol) + this.lStalp);
					});
					l_totala = l_totala - l_portiA;
				}
				l_totala = l_totala - this.configuration.panouri.buc * this.lStalp;
				return Number(l_totala / this.configuration.panouri.buc);
			} else {
				return 1500;
			}
		},
		suprafataPanouri() {
			if (this.configuration.panouri.is) {
				return (
					(this.lPanou * Number(this.hPanou) * this.configuration.panouri.buc) /
					1000
				).toFixed(2);
			} else return 0;
		},
		suprafataPP() {
			if (this.configuration.poarta_p.is) {
				let sp = 0;
				this.configuration.poarta_p.items.forEach((poarta) => {
					sp = sp + Number(poarta.latime_gol);
				});
				return ((sp * this.dimensions.ht) / 1000).toFixed(2);
			} else return 0;
		},
		suprafataPPIncluded() {
			if (this.configuration.poarta_a.is) {
				let sp = 0;
				this.configuration.poarta_a.items.forEach((poarta) => {
					if (poarta.pp_included) {
						sp = sp + Number(poarta.latime_pp);
					}
				});
				return ((sp * this.dimensions.ht) / 1000).toFixed(2);
			} else return 0;
		},
		suprafataPA() {
			if (this.configuration.poarta_a.is) {
				let sp = 0;
				this.configuration.poarta_a.items.forEach((poarta) => {
					sp = sp + Number(poarta.latime_gol);
					// Adding extra width to all sliding gates
					if (poarta.tip == "culisanta") {
						sp += this.extraWidthSlidingGate;
					}
					if (poarta.pp_included) {
						sp = sp - Number(poarta.latime_pp);
					}
				});
				return ((sp * this.dimensions.ht) / 1000).toFixed(2);
			} else return 0;
		},
		suprafataPAAP() {
			if (this.configuration.poarta_a.is) {
				let sp = 0;
				this.configuration.poarta_a.items.forEach((poarta) => {
					if (poarta.tip == "autoportanta") {
						sp = sp + Number(poarta.latime_gol);
						if (poarta.pp_included) {
							sp = sp - Number(poarta.latime_pp);
						}
					}
				});
				return ((sp * this.dimensions.ht) / 1000).toFixed(2);
			} else return 0;
		},
		suprafata() {
			return (
				Number(this.suprafataPanouri) +
				Number(this.suprafataPP) +
				Number(this.suprafataPPIncluded) +
				Number(this.suprafataPA)
			);
		},
		nrStalpi() {
			let fenceEl = 0
			const panouriBuc = this.configuration.panouri.is ? Number(this.configuration.panouri.buc) : 0
			const PPBuc = this.configuration.poarta_p.is ? Number(this.configuration.poarta_p.buc) : 0
			const PABuc = this.configuration.poarta_a.is ? Number(this.configuration.poarta_a.buc) : 0
			fenceEl = panouriBuc + PPBuc + PABuc
			return fenceEl + 1
		},
		suprafataBricks() {
			const areaStalp = this.dimensions.ht * this.lStalp / 1000;
			const areaStalpi = areaStalp * this.nrStalpi;
			let areaSoclu = 0

			if (this.configuration.panouri.is) {
				const areaSingleSoclu = this.dimensions.hp * this.lPanou / 1000
				areaSoclu = areaSingleSoclu * this.configuration.panouri.buc
			}
			const areaBricks = (areaStalpi + areaSoclu).toFixed(2)
			return areaBricks == 0 ? 0 : areaBricks
		},
		// suprafataBrickss() {
		// 	let suprafataTotala = this.dimensions.lt * this.dimensions.ht
		// 	let nrSlidingPA = 0
		// 	const configuration = JSON.parse(JSON.stringify(this.configuration))
		// 	configuration.poarta_a.items.forEach((poarta) => {
		// 		if (poarta.tip == "culisanta") {
		// 			nrSlidingPA += 1
		// 		}
		// 	});
		// 	const extraArea = nrSlidingPA * this.extraWidthSlidingGate / 1000 * this.dimensions.ht
		// 	suprafataTotala += extraArea

		// 	return suprafataTotala - this.suprafata
		// },
		lungimeParapet() {
			return Number(this.configuration.panouri.buc) * this.lPanou / 1000
		},
		priceMeasure() {
			const countryKey = this.country.toUpperCase();
			const priceKey = 'prices' + countryKey
			const priceMeasure = datas[priceKey].measure
			return priceMeasure || 0
		},
		priceMontage() {
			const countryKey = this.country.toUpperCase();
			const priceKey = 'prices' + countryKey
			const priceMontage = datas[priceKey].montage
			return priceMontage || 0
		},
		priceShipping() {
			const countryKey = this.country.toUpperCase();
			const priceKey = 'prices' + countryKey
			const priceShipping = datas[priceKey].shipping
			return priceShipping || 0
		},
		priceMMS() {
			return this.priceMeasure + this.priceShipping + this.priceMontage
		},
		pretTotal() {
			let curs = 1;
			const clientCounty = this.client.judet
			const countyPrice = this.getCountyPrice(clientCounty.value)

			// Legacy prices if no countyPrice
			let priceTag = countyPrice ? Number(countyPrice.price_panel) : clientCounty.price
			console.log('priceTag:', priceTag)

			let priceTagPR = countyPrice ? Number(countyPrice.price_panel_frame) : 0;
			let priceTagPP = countyPrice ? Number(countyPrice.price_gate_pedestrian) : 0;
			let priceTagPA = countyPrice ? Number(countyPrice.price_gate_swing) : 0;
			let priceTagPAS = countyPrice ? Number(countyPrice.price_gate_slide) : 0;
			let priceTagPAAP = countyPrice ? Number(countyPrice.price_gate_selfsupport) : 0;
			// Legacy prices
			if (!countyPrice && this.country == "ro") {
				priceTagPR = priceTag + datas.prices.p_rama;
				priceTagPP = priceTag + datas.prices.pp;
				priceTagPA = priceTag + datas.prices.pa;
				priceTagPAS = priceTag + datas.prices.pas;
				priceTagPAAP = priceTag + datas.prices.paap;
			} else if (!countyPrice && this.country == "hu") {
				// curs = this.curr_huf;
				priceTagPR = priceTag * datas.pricesHU.p_rama;
				priceTagPP = priceTag + datas.pricesHU.pp;
				priceTagPA = priceTag + datas.pricesHU.pa;
				priceTagPAS = priceTag + datas.pricesHU.pas;
				priceTagPAAP = priceTag + datas.pricesHU.paap;
			} else if (!countyPrice && this.country == "de") {
				priceTagPR = priceTag * datas.pricesDE.p_rama;
				priceTagPP = priceTag + datas.pricesDE.pp;
				priceTagPA = priceTag + datas.pricesDE.pa;
				priceTagPAS = priceTag + datas.pricesDE.pas;
				priceTagPAAP = priceTag + datas.pricesDE.paap;
			} else if (!countyPrice && this.country == "at") {
				priceTagPR = priceTag * datas.pricesAT.p_rama;
				priceTagPP = priceTag + datas.pricesAT.pp;
				priceTagPA = priceTag + datas.pricesAT.pa;
				priceTagPAS = priceTag + datas.pricesAT.pas;
				priceTagPAAP = priceTag + datas.pricesAT.paap;
			} else if (!countyPrice && this.country == "fr") {
				priceTagPR = priceTag * datas.pricesFR.p_rama;
				priceTagPP = priceTag + datas.pricesFR.pp;
				priceTagPA = priceTag + datas.pricesFR.pa;
				priceTagPAS = priceTag + datas.pricesFR.pas;
				priceTagPAAP = priceTag + datas.pricesFR.paap;
			} else if (!countyPrice && this.country == "be") {
				priceTagPR = priceTag * datas.pricesBE.p_rama;
				priceTagPP = priceTag + datas.pricesBE.pp;
				priceTagPA = priceTag + datas.pricesBE.pa;
				priceTagPAS = priceTag + datas.pricesBE.pas;
				priceTagPAAP = priceTag + datas.pricesBE.paap;
			}
			if (!countyPrice && this.model == "vertical") {
				priceTag += 15;
				priceTagPR += 15;
				priceTagPP += 15;
				priceTagPA += 15;
				priceTagPAS += 15;
				priceTagPAAP += 15;
			}

			// Price increase for below min surface
			let suprafataPanou =
				Number(this.suprafataPanouri) / this.configuration.panouri.buc;
			let pricePanouri = this.configuration.panouri.panelFrame
				? Number(this.suprafataPanouri) *
				priceTagPR *
				this.raportSuprafataMin(
					Number(suprafataPanou),
					this.suprafata_limita_panou
				) *
				curs
				: Number(this.suprafataPanouri) *
				priceTag *
				this.raportSuprafataMin(
					Number(suprafataPanou),
					this.suprafata_limita_panou
				) *
				curs;

			let pricePP = this.getPretPP(priceTagPP, curs);
			let pricePA = this.getPretPA(priceTagPA, priceTagPAS, priceTagPAAP, curs);

			// let pricePA =
			// 	((Number(this.suprafataPA) - Number(this.suprafataPAAP)) * priceTagPA +
			// 		Number(this.suprafataPAAP) * priceTagPAAP) *
			// 	curs;

			let total = 0;
			console.log('Prices:', pricePanouri, pricePP, pricePA)
			total = pricePanouri + pricePP + pricePA;
			const countries = ["de", "at", "hu", "fr", "be"];

			if (countries.includes(this.country)) {
				total = total + this.priceMMS;
				total = total * 1.21;
			}

			total = total.toFixed(2);

			return total;
		},
		finalImg() {
			return this.$refs.comandaComponent.$refs.finalImg.image;
		},
	},
	watch: {
		// showContact(val) {
		//   if (val) {
		//     setTimeout(() => {
		//       this.showContact = false;
		//     }, 3000);
		//   }
		// },
		model(val) {
			if (val == "horizontal") {
				this.defaultProfil = 100;
				this.img = "horizontal_4_1_1.png";
			} else {
				this.defaultProfil = 60;
				this.img = "vertical_4_1_1.png";
			}
		},
		"dimensions.lt"(val) {
			if (val < 7) {
				this.$refs.config.ifPanels(false);
			} else {
				this.$refs.config.ifPanels(true);
			}
		},
		bricksOfferSelected(newVal, oldVal) {
			if (newVal, oldVal) {
				this.completedBricksOffer = newVal
			}
		}
	},
	methods: {
		formatHUprice(val) {
			return val.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		},
		forceRerender() {
			this.componentKey += 1;
		},
		updateBricksOfferSelected(value) {
			this.bricksOfferSelected = value
		},
		raportSuprafataMin(suprafata, minsuprafata) {
			if (suprafata < minsuprafata) {
				let raport = 2 - suprafata / minsuprafata
				raport = raport > 1.3 ? 1.3 : raport
				return raport;
			} else {
				return 1;
			}
		},
		getPretPP(priceTagPP, curs) {
			let pricePP = 0;
			let pricePPIncluded = 0;
			const ht = this.dimensions.ht;
			if (this.configuration.poarta_p.is) {
				this.configuration.poarta_p.items.forEach((poarta) => {
					let suprafata = ((Number(poarta.latime_gol) * ht) / 1000).toFixed(2);
					let price =
						Number(suprafata) *
						priceTagPP *
						this.raportSuprafataMin(
							Number(suprafata),
							this.suprafata_limita_pp
						) *
						curs;
					pricePP = pricePP + price;
				});
			}
			if (this.configuration.poarta_a.is) {
				this.configuration.poarta_a.items.forEach((poarta) => {
					if (poarta.pp_included) {
						let suprafata = ((Number(poarta.latime_pp) * ht) / 1000).toFixed(2);
						let price =
							Number(suprafata) *
							priceTagPP *
							this.raportSuprafataMin(
								Number(suprafata),
								this.suprafata_limita_pp
							) *
							curs;
						pricePPIncluded = pricePPIncluded + price;
					}
				});
			}
			return pricePP + pricePPIncluded;
		},
		getPretPA(priceTagPA, priceTagPAS, priceTagPAAP, curs) {
			let pricePA = 0;
			let pricePAS = 0;
			let pricePAAP = 0;
			const ht = this.dimensions.ht;
			if (this.configuration.poarta_a.is) {
				this.configuration.poarta_a.items.forEach((poarta) => {
					if (poarta.tip == "autoportanta") {
						let latimePoarta = Number(poarta.latime_gol);
						let raport = this.suprafata_limita_pa;
						if (poarta.pp_included) {
							latimePoarta = latimePoarta - Number(poarta.latime_pp);
							raport = this.suprafata_limita_pa_pp_included;
						}
						let suprafata = ((latimePoarta * ht) / 1000).toFixed(2);
						let price =
							Number(suprafata) *
							priceTagPAAP *
							this.raportSuprafataMin(Number(suprafata), raport) *
							curs;
						pricePAAP = pricePAAP + price;
					} else if (poarta.tip == "culisanta") {
						// Adding extra width to all sliding gates
						let latimePoarta = Number(poarta.latime_gol) + this.extraWidthSlidingGate;
						let raport = this.suprafata_limita_pa;
						if (poarta.pp_included) {
							latimePoarta = latimePoarta - Number(poarta.latime_pp);
							raport = this.suprafata_limita_pa_pp_included;
						}
						let suprafata = ((latimePoarta * ht) / 1000).toFixed(2);
						let price =
							Number(suprafata) *
							priceTagPAS *
							this.raportSuprafataMin(Number(suprafata), raport) *
							curs;
						pricePAS = pricePAS + price;
					} else {
						let latimePoarta = Number(poarta.latime_gol);

						let raport = this.suprafata_limita_pa;
						if (poarta.pp_included) {
							latimePoarta = latimePoarta - Number(poarta.latime_pp);
							raport = this.suprafata_limita_pa_pp_included;
						}
						let suprafata = ((latimePoarta * ht) / 1000).toFixed(2);
						let price =
							Number(suprafata) *
							priceTagPA *
							this.raportSuprafataMin(Number(suprafata), raport) *
							curs;
						pricePA = pricePA + price;
					}
				});
			}
			return pricePA + pricePAS + pricePAAP;
		},
		scroll() {
			window.onscroll = () => {
				let target = document.documentElement.offsetHeight - 100;
				let bottomOfWindow =
					Math.max(
						window.pageYOffset,
						document.documentElement.scrollTop,
						document.body.scrollTop
					) +
					window.innerHeight >=
					target;

				if (bottomOfWindow) {
					this.scrolledToBottom = true;
				} else {
					this.scrolledToBottom = false;
				}
			};
		},
		loadModel(value) {
			this.model = value;
			this.forceRerender();
		},
		loadColor(value) {
			this.color = value;
		},
		loadDims(value) {
			this.dimensions = value;
		},
		loadConfig(obj) {
			this.configuration = obj.configuration;
			this.img = obj.img;
		},
		loadValidConfig(value) {
			this.validConfig = value;
		},
		loadPanel(value) {
			this.panel = value;
		},
		loadFormValid(value) {
			this.validOfertaForm = value;
		},
		loadFormValidCallback(value) {
			this.validCallbackForm = value;
		},
		loadClientData(value) {
			this.client = value;
		},
		loadDraw() {
			setTimeout(() => {
				this.$refs.panel.clearDrawing();
				this.$refs.panel.updateDrawing();
			}, 50);
		},
		replaceSpecialCh(str) {
			return str
				.replace(/ș|Ș/g, "s")
				.replace(/ț|Ț/g, "t")
				.replace(/î|Î/g, "i")
				.replace(/ă|â|Â|Ă/g, "a");
		},
		changeStep(val) {
			let n = Number(this.currentStep);
			if (val == "next") {
				this.currentStep = n + 1;
				if (this.currentStep == 5) {
					this.loadDraw();
				}
			} else if (val == "prev") {
				if (this.currentStep == 6) {
					if (this.completed) {
						this.completed = false;
					} else {
						this.currentStep = n - 1;
						this.loadDraw();
					}
				} else {
					this.currentStep = n - 1;
				}
			}

			// send custom event to gtm
			this.$gtm.trackEvent({
				event: 'configurator_navigation',
				category: 'Configurator',
				action: 'Step Change',
				label: `Step ${this.currentStep}`,
				value: this.currentStep,
				noninteraction: false,
			});

			this.$vuetify.goTo(this.scrollTarget, this.scrollOptions);
		},
		async addCerere() {
			let baseUrl = process.env.VUE_APP_RO_HUB_API_HOST
			let path = "api/garduri/cereri/add"
			// if (this.country == "hu") {
			// 	baseUrl = process.env.VUE_APP_HU_HUB_API_HOST
			// 	path = "api/fence/inquiries/add"
			// }
			if (this.country == "at" || this.country == "de" || this.country == 'hu' || this.country == 'fr' || this.country == "be") {
				path = "api/fence/inquiries/add"
			}

			const url = baseUrl + path;

			// Adding extra width to all sliding gates before sent to backend
			// let newConfiguration = Object.assign({}, this.configuration);
			const newConfiguration = JSON.parse(JSON.stringify(this.configuration))
			newConfiguration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "culisanta") {
					poarta.latime_gol =
						Number(poarta.latime_gol) + this.extraWidthSlidingGate;
				}
			});

			['_fbp', '_fbc'].forEach(key => {
				const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + key + '=([^;]*)'));
				if (match) this.utmParams[key] = match[1];
			});

			const return_id = await axios
				.post(url, {
					data: this.today.format("YYYY-MM-DD"),
					currency: this.curr_huf,
					partener: this.partener_version,
					client_obj: JSON.stringify(this.client),
					prices: JSON.stringify(this.getCountyPrice(this.client.judet.value)),
					gard_obj: JSON.stringify({
						model: this.model,
						color: this.color,
						dimensions: this.dimensions,
						configuration: newConfiguration,
						img: this.img,
						panel: this.panel,
						lPanou: this.lPanou,
						hPanou: this.hPanou,
						suprafataPanouri: this.suprafataPanouri,
						suprafataPP: this.suprafataPP,
						suprafataPPIncluded: this.suprafataPPIncluded,
						suprafataPA: this.suprafataPA,
						suprafata: this.suprafata,
						pretTotal: this.pretTotal,
					}),
					bricks_selected: this.bricksOfferSelected,
					country: this.country,
					utm_params: JSON.stringify(this.utmParams)
				})
				.then((response) => {
					// console.log(response.data.notice.id);
					return response.data.notice.id;
				})
				.catch((error) => {
					console.error(error);
					return "not assigned";
				});
			return return_id;
		},
		// async requestOffers() {
		// 	await this.requestOferta();
		// 	if (this.bricksOfferSelected) {
		// 		await this.requestBricksOffer()
		// 	}
		// },
		async requestOferta() {
			if ((this.client.name == undefined || this.client.name == "")) {
				this.$refs.comandaComponent.setFocus("name");
				this.alert.status = true;
				this.alert.type = "warning";
				this.alert.text = this.language.offer.alerts.name;
			} else if (this.client.surname == undefined || this.client.surname == "") {
				this.$refs.comandaComponent.setFocus("surname");
				this.alert.status = true;
				this.alert.type = "warning";
				this.alert.text = this.language.offer.alerts.surname;
			} else if (this.client.email == undefined || this.client.email == "") {
				this.$refs.comandaComponent.setFocus("email");
				this.alert.status = true;
				this.alert.type = "warning";
				this.alert.text = this.language.offer.alerts.email;
			} else if ((this.country == "ro" || this.country == "hu") && (this.client.phone == undefined || this.client.phone == "")) {
				this.$refs.comandaComponent.setFocus("phone");
				this.alert.status = true;
				this.alert.type = "warning";
				this.alert.text = this.language.offer.alerts.phone;
			} else if (this.client.judet == undefined || this.client.judet == "") {
				this.$refs.comandaComponent.setFocus("county");
				this.alert.status = true;
				this.alert.type = "warning";
				this.alert.text = this.language.offer.alerts.county;
			} else if (
				this.country == "ro" && ['Bucuresti', 'Ilfov'].includes(this.client.judet.value) && (
					this.bricksOfferSelected == undefined ||
					this.bricksOfferSelected == null)
			) {
				this.$refs.comandaComponent.bricksAddonError = true;
				this.alert.status = true;
				this.alert.type = "warning";
				this.alert.text = 'Alegeti daca doriti oferta pentru boltari';
			} else if (!this.validOfertaForm) {
				this.alert.status = true;
				this.alert.type = "error";
				this.alert.text = this.language.offer.alerts.failed;
			} else {
				// Valid execution
				// if (this.country == "ro") {
				// 	this.sendConversion();
				// }
				this.generatingOferta = true;
				this.nrOferta = process.env.NODE_ENV === 'production' ? await this.addCerere() : 0;
				this.pdfDoc = await this.generateOferta();

				// if (['at'].includes(this.country)) {
				// 	this.sendOferta();
				// }

				if (process.env.NODE_ENV === 'production') {
					this.sendNotification();
				}
				this.generatingOferta = false;
				this.completed = true;

				if (this.bricksOfferSelected) {
					this.generatingBricksOffer = true;
					this.noBricksOffer = await this.addBricksCerere();
					this.pdfBricksDoc = await this.generateBriksOffer();
					this.sendBricksNotification();
					this.generatingBricksOffer = false;
					this.completedBricksOffer = true;
				}

				this.alert.status = true;
				this.alert.type = "info";
				this.alert.text = this.language.offer.alerts.success;
			}
		},
		isVioletZoneJudet() {
			const arr_violetzone = datas.arr_violetzone;
			if (arr_violetzone.includes(this.client.judet.text)) {
				return true;
			} else {
				return false;
			}
		},
		isBlueZoneJudet() {
			const arr_bluezone = datas.arr_bluezone;
			if (arr_bluezone.includes(this.client.judet.text)) {
				return true;
			} else {
				return false;
			}
		},
		isOrangeZoneJudet() {
			const arr_orangezone = datas.arr_orangezone;
			if (arr_orangezone.includes(this.client.judet.text)) {
				return true;
			} else {
				return false;
			}
		},
		isGreenZoneJudet() {
			const arr_greenzone = datas.arr_greenzone;
			if (arr_greenzone.includes(this.client.judet.text)) {
				return true;
			} else {
				return false;
			}
		},
		async generateOferta() {
			const doc = new jsPDF();

			// add the font to jsPDF
			doc.addFileToVFS("Roboto-Regular.ttf", fonts.robotoRegular);
			doc.addFileToVFS("Roboto-Bold.ttf", fonts.robotoBold);
			doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
			doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

			// set font
			doc.setFont("Roboto");
			doc.setFontStyle("normal");
			// Document - Top bar Info
			// Draw grey header rectangle
			doc.setFillColor(242, 244, 248);
			doc.rect(0, 0, 210, 25, "F");

			// Add Logo
			// if (this.country == "hu") {
			// 	doc.addImage(datas.logo_hu, "JPEG", 10, 5, 44, 13);
			// } else 
			if (this.country == "ro") {
				doc.addImage(datas.logo_new, "JPEG", 10, 9, 50, 11);
			} else {
				doc.addImage(datas.logo_istruct, "JPEG", 10, 11, 50, 6);
			}

			// Add Info
			doc.setFontSize(8);
			doc.setTextColor(150);

			doc.text(this.language.pdf.header.company, 69, 11, {
				lineHeightFactor: 1.6,
			});
			doc.text(this.language.pdf.header.address, 118, 11, {
				lineHeightFactor: 1.6,
			});
			doc.text(this.language.pdf.header.contact, 164, 11, {
				lineHeightFactor: 1.6,
			});

			doc.setDrawColor(160, 171, 192);
			doc.setLineWidth(0.5);
			doc.line(0, 25, 210, 25);

			let space = 35;

			if (this.country == 'ro' || this.country == 'hu') {
				doc.setFontSize(9);
				doc.setTextColor(100);
				doc.setFontStyle("bold");

				doc.text(this.language.pdf.labels.to, 10, space);
				doc.text(this.language.pdf.labels.email, 10, space + 5);
				doc.text(this.language.pdf.labels.phone, 10, space + 10);
				let toTextSize = doc.getTextWidth(this.language.pdf.labels.to);
				let emailTextSize = doc.getTextWidth(this.language.pdf.labels.email);
				let phoneTextSize = doc.getTextWidth(this.language.pdf.labels.phone);

				doc.setFontStyle("normal");
				let nume = this.replaceSpecialCh(this.client.name);
				nume += " ";
				nume += this.replaceSpecialCh(this.client.surname);
				doc.text(nume, 12 + toTextSize, space);
				doc.text(this.client.email, 12 + emailTextSize, space + 5);
				doc.text(this.client.phone, 12 + phoneTextSize, space + 10);
				space = space + 15
			}

			doc.setFontSize(12);
			doc.setTextColor(160, 171, 192);
			doc.setFontStyle("bold");
			doc.text(this.language.pdf.main_title, 10, space + 10);
			doc.setFontSize(9);
			doc.setTextColor(100);
			doc.setFontStyle("normal");
			let currentDate =
				this.country == "hu"
					? this.today.format("YYYY.MM.DD")
					: this.today.format("DD.MM.YYYY");
			let currentNr = this.nrOferta ? `Nr: ${this.nrOferta} / ` : "";
			doc.text(currentNr + currentDate, 10, space + 15);

			space = space + 28;
			doc.setFontStyle("bold");
			let config = this.img
				.replace("horizontal_", "").replace("vertical_", "")
				.substring(0, 3);
			let first = config.charAt(0);
			let second = config.slice(-1);
			let piece_text = " " + this.language.configuration.labels.piece;

			if (first == "7") {
				if (second == "4") {
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						27,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 79, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 156, space);
				} else if (second == "5") {
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						25,
						space
					);
					doc.text(String(this.poarta_ac_buc) + piece_text, 68, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 132, space);
				} else if (second == "6") {
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						25,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 68, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 132, space);
				} else if (second == "7") {
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						19,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 52, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 100, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 147, space);
				} else {
					let indent = 57;
					if (this.poarta_aap_buc > 0) {
						indent = 37;
					}
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						indent,
						space
					);
					doc.text(
						String(this.configuration.poarta_a.buc) + piece_text,
						indent + 63,
						space
					);
				}
				// end first = 7
			} else if (first == "6") {
				if (second == "4") {
					doc.text(String(this.poarta_ab_buc) + piece_text, 57, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 147, space);
				} else if (second == "5") {
					doc.text(String(this.poarta_ac_buc) + piece_text, 47, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 123, space);
				} else if (second == "6") {
					doc.text(String(this.poarta_ab_buc) + piece_text, 47, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 123, space);
				} else if (second == "7") {
					doc.text(String(this.poarta_ab_buc) + piece_text, 37, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 91, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 143, space);
				} else {
					doc.text(
						String(this.configuration.poarta_a.buc) + piece_text,
						100,
						space
					);
				}
				// end first = 6
			} else if (first == "5") {
				doc.text(
					String(this.configuration.poarta_p.buc) + piece_text,
					100,
					space
				);
			} else if (first == "4") {
				if (second == "4") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						26,
						space
					);
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						60,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 102, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 162, space);
				} else if (second == "5") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						26,
						space
					);
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						54,
						space
					);
					doc.text(String(this.poarta_ac_buc) + piece_text, 91, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 143, space);
				} else if (second == "6") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						26,
						space
					);
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						54,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 91, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 143, space);
				} else if (second == "7") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						23,
						space
					);
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						44,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 73, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 113, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 155, space);
				} else {
					let indent1 = 39;
					let indent2 = 85;
					let indent3 = 145;
					if (this.poarta_aap_buc > 0) {
						indent1 = 33;
						indent2 = 73;
						indent3 = 123;
					}
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						indent1,
						space
					);
					doc.text(
						String(this.configuration.poarta_p.buc) + piece_text,
						indent2,
						space
					);
					doc.text(
						String(this.configuration.poarta_a.buc) + piece_text,
						indent3,
						space
					);
				}
				// end first = 4
			} else if (first == "3") {
				if (second == "4") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						31,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 89, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 156, space);
				} else if (second == "5") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						30,
						space
					);
					doc.text(String(this.poarta_ac_buc) + piece_text, 78, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 137, space);
				} else if (second == "6") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						30,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 78, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 137, space);
				} else if (second == "7") {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						23,
						space
					);
					doc.text(String(this.poarta_ab_buc) + piece_text, 59, space);
					doc.text(String(this.poarta_ac_buc) + piece_text, 102, space);
					doc.text(String(this.poarta_aap_buc) + piece_text, 152, space);
				} else {
					doc.text(
						String(this.configuration.panouri.buc) + piece_text,
						55,
						space
					);
					doc.text(
						String(this.configuration.poarta_a.buc) + piece_text,
						129,
						space
					);
				}
				// end first = 3
			} else if (first == "2") {
				doc.text(
					String(this.configuration.panouri.buc) + piece_text,
					82,
					space
				);
				doc.text(
					String(this.configuration.poarta_p.buc) + piece_text,
					128,
					space
				);
			} else if (first == "1") {
				doc.text(
					String(this.configuration.panouri.buc) + piece_text,
					100,
					space
				);
			}

			space = space + 2;

			// Add Fence Image
			const img = await this.finalImg;
			doc.addImage(img, "PNG", 10, space, 190, 59, "", "FAST");
			space = space + 72;
			doc.setFontSize(7);
			doc.text(this.language.pdf.image_info, 105, space - 10, {
				align: "center",
			});

			// Left column
			doc.setFontSize(9);
			doc.setTextColor(100);
			doc.setFontStyle("bold");
			let textSize1 = doc.getTextWidth(this.language.offer.labels.model);
			let textSize2 = doc.getTextWidth(this.language.offer.labels.color);
			let textSize3 = doc.getTextWidth(
				this.language.offer.labels.profile_width
			);
			let textSize4 = doc.getTextWidth(
				this.language.offer.labels.profile_distance
			);
			doc.text(this.language.offer.labels.model, 12, space);
			doc.text(this.language.offer.labels.color, 12, space + 5);
			doc.text(this.language.offer.labels.profile_width, 12, space + 10);
			doc.text(this.language.offer.labels.profile_distance, 12, space + 15);

			doc.setFontStyle("normal");
			doc.text(this.modelText, 12 + textSize1, space);
			doc.text(this.color.name, 12 + textSize2, space + 5);
			doc.text(
				String(this.panel.selectedProfil) + " mm",
				12 + textSize3,
				space + 10
			);
			doc.text(this.golText, 12 + textSize4, space + 15);

			// Right column
			doc.setFontStyle("bold");
			doc.text(this.language.pdf.features_title, 110, space);
			// doc.setFontSize(8);
			doc.setFontStyle("normal");
			doc.text(this.language.pdf.features, 110, space + 5, {
				lineHeightFactor: 1.4,
			});
			space = space + 25;

			doc.setFontSize(9);
			doc.setTextColor(100);
			doc.setFontStyle("bold");
			let textSize5 = doc.getTextWidth(this.language.offer.labels.total_area);
			let textSize6 = doc.getTextWidth(this.language.offer.labels.panels_area);
			let textSize7 = doc.getTextWidth(this.language.offer.labels.person_areas);
			let textSize8 = doc.getTextWidth(this.language.offer.labels.car_areas);
			doc.text(this.language.offer.labels.total_area, 12, space);
			doc.text(this.language.offer.labels.panels_area, 12, space + 5);
			doc.text(this.language.offer.labels.person_areas, 12, space + 10);
			doc.text(this.language.offer.labels.car_areas, 12, space + 15);

			doc.setFontStyle("normal");
			doc.text(
				String(this.suprafata.toFixed(2)) + " m²",
				12 + textSize5,
				space
			);
			doc.text(
				String(this.suprafataPanouri) + " m²",
				12 + textSize6,
				space + 5
			);
			doc.text(
				String(Number(this.suprafataPP) + Number(this.suprafataPPIncluded)) +
				" m²",
				12 + textSize7,
				space + 10
			);
			doc.text(String(this.suprafataPA) + " m²", 12 + textSize8, space + 15);

			space = space + 30;

			doc.text(
				"• " +
				this.language.offer.alerts.concrete_alert1 +
				" " +
				this.language.offer.alerts.concrete_alert2,
				12,
				space
			);
			doc.text(this.language.pdf.footer.add_msg1, 12, space + 5);
			doc.text(this.language.pdf.footer.add_msg2, 12, space + 10);
			doc.text(this.language.pdf.footer.add_msg3, 12, space + 15);

			if (this.language.pdf.footer.add_msg4) {
				doc.text(this.language.pdf.footer.add_msg4, 12, space + 20);
				space = space + 5;
			}

			space = space + 20;

			// Totals
			doc.setDrawColor(150);
			doc.setLineWidth(0.4);
			doc.line(10, space, 200, space);

			// doc.setFontSize(7);
			doc.setFontStyle("bold");

			if (this.country == "at" || this.country == 'hu' || this.country == "be") {
				doc.text(`${this.language.pdf.price_title}`, 12, space + 5);
				const fencePrice = `${(Number(this.pretTotal) / 1.21 - this.priceMMS).toFixed(2)} EUR`
				doc.text(fencePrice, 198, space + 5, { align: "right" });

				space += 5;

				doc.text(`${this.language.pdf.footer.price_msg2} (${this.client.judet.text})`, 12, space + 5);
				const mmsPrice = `${(this.priceMMS).toFixed(2)} EUR`
				doc.text(mmsPrice, 198, space + 5, { align: "right" });

				// doc.text(
				// 	`${this.language.pdf.footer.price_msg1} ${this.client.judet.text}.`,
				// 	12,
				// 	space + 5
				// );
			} else if (this.country == "de" || this.country == 'fr') {
				doc.text(`${this.language.pdf.price_title}`, 12, space + 5);
				const fencePrice = `${(Number(this.pretTotal) / 1.21 - this.priceMMS).toFixed(2)} EUR`
				doc.text(fencePrice, 198, space + 5, { align: "right" });
			} else {
				doc.text(
					`${this.language.pdf.footer.price_msg1} ${this.client.judet.text}.`,
					12,
					space + 5
				);
				doc.setFontStyle("normal");
				doc.setFontSize(8);
				doc.text(this.language.pdf.footer.price_msg2, 12, space + 9);
			}

			doc.setFontSize(10);
			doc.setFontStyle("bold");
			let price_str = "";
			let priceM_str = "";
			let priceS_str = "";
			let totalPrice_str = "";

			// if (this.country == "hu") {
			// 	let priceFence = (Number(this.pretTotal) * 1.27).toFixed(0);
			// 	price_str = `${this.formatHUprice(priceFence)} ${this.language.pdf.footer.VAT_text
			// 		}`;
			// 	doc.text(this.formatHUprice(price_str), 198, space + 5, {
			// 		align: "right",
			// 	});

			// 	let priceMontage = (Number(this.pretMontaj) * 1.27).toFixed(0);
			// 	priceM_str = `${this.formatHUprice(priceMontage)} ${this.language.pdf.footer.VAT_text
			// 		}`;
			// 	doc.text(this.formatHUprice(priceM_str), 198, space + 9, {
			// 		align: "right",
			// 	});

			// 	let pretShipping = this.pretShipping;
			// 	priceS_str = `${this.formatHUprice(pretShipping.toString())} ${this.language.pdf.footer.VAT_text
			// 		}`;
			// 	doc.text(this.formatHUprice(priceS_str), 198, space + 13, {
			// 		align: "right",
			// 	});

			// 	let totalPrice =
			// 		Number(priceFence) + Number(priceMontage) + Number(pretShipping);
			// 	totalPrice_str = `${this.formatHUprice(String(totalPrice))} ${this.language.pdf.footer.VAT_text
			// 		}`;
			// 	doc.text("Összesen bruttóban:  " + totalPrice_str, 198, space + 18, {
			// 		align: "right",
			// 	});
			// } else 
			if (this.country == "de" || this.country == "at" || this.country == 'hu' || this.country == 'fr' || this.country == "be") {
				doc.setFontStyle("normal");
				let totalPriceWoVat = Number(this.pretTotal) / 1.21;
				let totalPriceVat = Number(this.pretTotal) - totalPriceWoVat;
				// let totalPriceVat_str = `MwSt. ${totalPriceVat.toFixed(2)} EUR`;
				let totalPriceWOVat_str = `${totalPriceWoVat.toFixed(2)} EUR`;
				totalPrice_str = `${this.language.pdf.footer.VAT_text}  ${this.pretTotal} EUR`;
				// let woVatPriceTextSize = doc.getTextWidth(totalPriceWOVat_str);
				// let vatPriceTextSize = doc.getTextWidth(totalPrice_str);

				doc.setFillColor(175, 213, 177);
				doc.rect(10, space + 7, 190, 6, "F");
				doc.setFillColor(253, 210, 157);
				doc.rect(10, space + 14, 190, 6, "F");

				doc.setFontSize(9);
				doc.setFontStyle("bold");

				doc.text(this.language.pdf.footer.price_no_VAT_msg, 12, space + 11, { align: "left" });
				doc.text(this.language.pdf.footer.price_VAT_msg, 12, space + 18, { align: "left" });
				// doc.text(totalPriceVat_str, 198, space + 9, {
				// 	align: "right",
				// });
				doc.setFontSize(10);
				doc.text(totalPriceWOVat_str, 198, space + 11, { align: "right" });
				doc.text(totalPrice_str, 198, space + 18, {
					align: "right",
				});
			} else {
				totalPrice_str = `${this.pretTotal} euro`;
				doc.text(totalPrice_str, 198, space + 5, { align: "right" });
			}

			doc.setFontSize(9);
			doc.setFontStyle("normal");
			if (this.country == "ro") {
				doc.text(this.language.pdf.footer.VAT_text, 198, space + 9, {
					align: "right",
				});
			}

			space = space + 25;
			// if (this.country == "hu") {
			// 	space += 20;
			// }

			// Footer info
			doc.setFontStyle("bold");
			let splitText = doc.splitTextToSize(
				this.language.pdf.footer.message,
				180
			);
			doc.text(12, space, splitText);

			let email = this.language.pdf.footer.email;
			let phone = this.language.pdf.footer.phone;
			doc.text(this.language.pdf.labels.email, 12, space + 10);
			if (phone) {
				doc.text(this.language.pdf.labels.phone, 12, space + 15);
			}
			if (['at', 'de', 'fr', 'be', 'hu'].includes(this.country)) {
				doc.text(this.language.pdf.labels.name, 12, space + 20);
			}

			doc.setFontStyle("normal");

			if (this.isVioletZoneJudet()) {
				email = "adrian.hailemas@i-struct.ro";
				phone = "0740 302 217";
			} else if (this.isBlueZoneJudet()) {
				email = "alexandru.pietrariu@i-struct.ro";
				phone = "0749 245 548";
			} else if (this.isOrangeZoneJudet()) {
				email = "sebastian.petculescu@i-struct.ro";
				phone = "0724 083 039";
			} else if (this.isGreenZoneJudet()) {
				email = "silvia.fecioru@i-struct.ro";
				phone = "0741 262 272";
			}

			doc.text(email, 23, space + 10);
			if (phone) {
				doc.text(phone, 29, space + 15);
			}
			if (['at', 'de', 'fr', 'be', 'hu'].includes(this.country)) {
				doc.text(this.language.pdf.footer.name, 22, space + 20);
			}
			let drop = 20
			if (this.country == "ro") {
				doc.setFontStyle("bold");
				doc.text("Proiecte realizate: ", 12, space + drop);
				doc.setFontStyle("normal");
				doc.text(this.language.pdf.footer.web, 39, space + drop);
			}

			// if (this.country == "ro") {
			// 	doc.text("Continuare pe pagina urmatoare", 8, 280);
			// 	doc.addPage();
			// 	space = 10;
			// 	carport_ad.print_carport_ad(doc, space + 6, datas);
			// 	space += 70
			// 	mag_pubele_ad.print_mag_pubele_ad(doc, space + 6, datas);
			// }

			console.log("GENERATED");
			this.metaPixelTrackGenerated();
			return doc;
		},
		metaPixelTrackGenerated() {
			fbq('trackCustom', 'Oferta generata', { generated: 'true' });
		},
		sendNotification() {
			const file = btoa(this.pdfDoc.output());

			let link = process.env.VUE_APP_RO_HUB_API_HOST;
			let authKey = process.env.VUE_APP_RO_HUB_API_KEY;

			// if (this.country == "hu") {
			// 	link = process.env.VUE_APP_HU_HUB_API_HOST;
			// 	authKey = process.env.VUE_APP_HU_HUB_API_KEY;
			// }

			if (this.country == "at" || this.country == 'de' || this.country == 'hu' || this.country == "fr" || this.country == "be") {
				link += "email/configurator_notification_eu";
			} else {
				link += "email/configurator_notification";
			}

			const headers = {
				headers: {
					x_api_key: authKey
				}
			}

			axios
				.post(
					link,
					{
						data: file,
						id_oferta: this.nrOferta ? this.nrOferta : "00",
						client_name: this.client.name,
						client_surname: this.client.surname,
						client_mail: this.client.email,
						client_phone: this.client.phone,
						client_judet: this.client.judet.value,
						client_timeframe: this.client.timeframe,
						client_message: this.client.message,
						country: this.country
					},
					headers
				)
				.then((response) => {
					console.log('Notification', response.data)
				})
				.catch((error) => {
					console.error(error);
				});
		},
		downloadOferta() {
			this.pdfDoc.save(this.language.pdf.filename);
		},
		sendOferta() {
			this.sendingOferta = true;
			const file = btoa(this.pdfDoc.output());

			let bricksFile = null;
			if (this.bricksOfferSelected) {
				bricksFile = btoa(this.pdfBricksDoc.output());
			}

			let link = process.env.VUE_APP_RO_HUB_API_HOST;
			let authKey = process.env.VUE_APP_RO_HUB_API_KEY;

			// if (this.country == "hu") {
			// 	// link = "https://hub.i-struct.hu/app/mail_configurator_client.php";
			// 	link = process.env.VUE_APP_HU_HUB_API_HOST;
			// 	authKey = process.env.VUE_APP_HU_HUB_API_KEY;
			// }

			if (this.country == "hu") {
				link += "email/configurator_client_hu";
			} else if (this.country == "de") {
				link += "email/configurator_client_de";
			} else if (this.country == "at") {
				link += "email/configurator_client_at";
			} else if (this.country == "fr") {
				link += "email/configurator_client_fr";
			} else if (this.country == "be") {
				link += "email/configurator_client_be";
			} else {
				link += "email/configurator_client";
			}

			const headers = {
				headers: {
					x_api_key: authKey
				}
			}

			axios
				.post(
					link,
					{
						data: file,
						data_bricks: bricksFile,
						client_name: `${this.client.name} ${this.client_surname}`,
						client_mail: this.client.email,
					},
					headers
				)
				.then((response) => {
					this.sendingOferta = false;
					if (response.data.includes("SENT")) {
						this.email_success = true;
					} else {
						console.log(response.data);
						this.email_error = true;
					}
					// console.log(response);
				})
				.catch((error) => {
					this.sendingOferta = false;
					this.email_error = true;
					console.error(error);
				});
		},
		get_huf_currency() {
			axios
				.get(process.env.VUE_APP_HU_HUB_API_HOST + "api/currency", {
					headers: {
						Authorization: process.env.VUE_APP_HU_HUB_API_KEY,
					},
				})
				.then((response) => {
					// console.log(response.data.curr);
					this.curr_huf = response.data.curr;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		sendConversion: function () {
			this.$gtag.reportConversion({
				send_to: "AW-832172065/wjuBCNDN7o8DEKHg54wD",
			});
		},
		// async requestBricksOffer() {
		// 	this.generatingBricksOffer = true;
		// 	this.noBricksOffer = await this.addBricksCerere();
		// 	this.pdfBricksDoc = await this.generateBriksOffer();
		// 	this.sendBricksNotification();
		// 	this.generatingBricksOffer = false;
		// 	this.completedBricksOffer = true;
		// },
		async addBricksCerere() {
			const url = "https://hub.cuprolli.ro/app_back/index.php/api/garduri/zidarie/cereri/add";

			const bricksPrice = this.suprafataBricks * bricksData.bricksPrices.boltari * 1.21;
			const capaceStalpPrice = this.nrStalpi * bricksData.bricksPrices.capac_stalp * 1.21;
			let capaceInterval = 0
			if (this.configuration.panouri.is) {
				capaceInterval = this.lungimeParapet * bricksData.bricksPrices.capac_interval * 1.21;
			}
			const totalPrice = (bricksPrice + capaceStalpPrice + capaceInterval);

			const return_id = await axios
				.post(url, {
					data: this.today.format("YYYY-MM-DD"),
					cerere_id: this.nrOferta,
					client_obj: JSON.stringify(this.client),
					bricks_obj: JSON.stringify({
						nrStalpi: this.nrStalpi,
						suprafataBricks: this.suprafataBricks,
						lungimeParapet: this.lungimeParapet,
						nrPanouri: this.configuration.panouri.buc,
						lPanou: this.lPanou,
						nrPP: this.configuration.poarta_p.buc,
						nrPA: this.configuration.poarta_a.buc,
						dimensions: this.dimensions,
						bricksPrice: bricksPrice,
						capaceStalpPrice: capaceStalpPrice,
						capaceInterval: capaceInterval,
						totalPrice: totalPrice
					})
				})
				.then((response) => {
					console.log(response.data.notice.id);
					return response.data.notice.id;
				})
				.catch((error) => {
					console.error(error);
					return "not assigned";
				});
			return return_id;
		},
		async generateBriksOffer() {
			const doc = new jsPDF();

			// add the font to jsPDF
			doc.addFileToVFS("Roboto-Regular.ttf", fonts.robotoRegular);
			doc.addFileToVFS("Roboto-Bold.ttf", fonts.robotoBold);
			doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
			doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

			// set font
			doc.setFont("Roboto");
			doc.setFontStyle("normal");
			// Document - Top bar Info
			// Draw grey header rectangle
			doc.setFillColor(242, 244, 248);
			doc.rect(0, 0, 210, 25, "F");

			// Add Logo
			doc.addImage(bricksData.logo_vivalanda, "JPEG", 9, 9, 74, 11);

			// Add Company Info
			doc.setFontSize(8);
			doc.setTextColor(150);
			doc.text(['VIVALANDA DESIGN SRL', 'CUI: RO 47203486', 'RegCom: J40/23079/2022'], 114, 11, {
				lineHeightFactor: 1.6,
			});
			doc.text(['Adresa: Bucuresti', 'https://vivalanda.ro', 'Email: contact@vivalanda.ro'], 162, 11, {
				lineHeightFactor: 1.6,
			});
			doc.setDrawColor(160, 171, 192);
			doc.setLineWidth(0.5);
			doc.line(0, 25, 210, 25);

			//Client details
			doc.setFontSize(9);
			doc.setTextColor(100);
			doc.setFontStyle("bold");
			doc.text(this.language.pdf.labels.to, 10, 35);
			doc.text(this.language.pdf.labels.email, 10, 40);
			doc.text(this.language.pdf.labels.phone, 10, 45);
			let toTextSize = doc.getTextWidth(this.language.pdf.labels.to);
			let emailTextSize = doc.getTextWidth(this.language.pdf.labels.email);
			let phoneTextSize = doc.getTextWidth(this.language.pdf.labels.phone);
			doc.setFontStyle("normal");
			let nume = this.replaceSpecialCh(this.client.name);
			nume += " ";
			nume += this.replaceSpecialCh(this.client.surname);
			doc.text(nume, 12 + toTextSize, 35);
			doc.text(this.client.email, 12 + emailTextSize, 40);
			doc.text(this.client.phone, 12 + phoneTextSize, 45);

			//Title and date
			doc.setFontSize(12);
			doc.setFontStyle("bold");
			doc.text('OFERTA DE PRET - STALPI SI SOCLU DIN BOLTARI PREFABRICATI', 10, 60);
			doc.setFontSize(9);
			doc.setTextColor(100);
			doc.setFontStyle("normal");
			let currentDate = this.today.format("DD.MM.YYYY")
			let currentNr = this.noBricksOffer ? `Nr: ${this.noBricksOffer} / ` : "";
			doc.text(currentNr + currentDate, 10, 65);

			let space = 70;

			const bricksPrice = this.suprafataBricks * bricksData.bricksPrices.boltari * 1.21;
			const capaceStalpPrice = this.nrStalpi * bricksData.bricksPrices.capac_stalp * 1.21;
			let capaceInterval = 0
			if (this.configuration.panouri.is) {
				capaceInterval = this.lungimeParapet * bricksData.bricksPrices.capac_interval * 1.21;
			}
			const totalPrice = (bricksPrice + capaceStalpPrice + capaceInterval);

			// Add Fence Schetch
			doc.addImage(bricksData.img_sketch, "JPG", 10, space, 190, 57, "", "FAST");

			space = space + 74;

			doc.setFontSize(7);
			doc.text('* Pozele au caracter exemplificativ', 105, space - 10, {
				align: "center",
			});

			doc.addImage(bricksData.imgProduct, "JPG", 10, space, 60, 64, "", "FAST");

			// Left column
			space = space + 10
			doc.setFontSize(10);
			doc.setTextColor(100);

			// Labels
			doc.setFontStyle("bold");
			const label1 = 'Suprafata boltari: '
			const label2 = 'Nr. stalpi: '
			let textSizeLabel1 = doc.getTextWidth(label1);
			let textSizeLabel2 = doc.getTextWidth(label2);
			doc.text(label1, 82, space);
			doc.text(label2, 82, space + 5);
			doc.setFontStyle("normal");
			doc.text(this.suprafataBricks + ' m²', 82 + textSizeLabel1, space);
			doc.text(this.nrStalpi + ' buc', 82 + textSizeLabel2, space + 5);

			space = space + 15

			doc.setFontStyle("bold");
			doc.text('Boltari prefabricati (stalpi + soclu): ', 82, space);
			doc.setFontStyle("normal");
			doc.text(bricksPrice.toFixed(2) + ' euro', 198, space, {
				align: "right",
			});

			space = space + 6
			doc.setFontStyle("bold");
			doc.text('Palarii stalpi (capac stalp + capitel cu picurator): ', 82, space);
			doc.setFontStyle("normal");
			doc.text(capaceStalpPrice.toFixed(2) + ' euro', 198, space, {
				align: "right",
			});

			if (this.configuration.panouri.is) {
				space = space + 6
				doc.setFontStyle("bold");
				doc.text('Capace interval (capace soclu): ', 82, space);
				doc.setFontStyle("normal");
				doc.text(capaceInterval.toFixed(2) + ' euro', 198, space, {
					align: "right",
				});
			}

			space = space + 6

			// Totals
			doc.setDrawColor(150);
			doc.setLineWidth(0.4);
			doc.line(80, space, 200, space);

			doc.setFontSize(10);
			doc.setFontStyle("bold");
			doc.text('TOTAL', 82, space + 5);
			doc.text(totalPrice.toFixed(2) + ' euro', 198, space + 5, { align: "right" });
			doc.setFontSize(9);
			doc.setFontStyle("normal");
			doc.text(this.language.pdf.footer.VAT_text, 198, space + 9, {
				align: "right",
			});

			space = space + 13

			doc.setFontStyle("normal");
			doc.setFontSize(8);
			let splitExtraText = doc.splitTextToSize(
				'Valoarea finala a facturii va fi calculata in lei la cursul de schimb din data facturarii.',
				80
			);
			doc.text(splitExtraText, 82, space);

			space = space + 24

			doc.setFontSize(9);
			doc.setFontStyle("bold");
			let splitTextContact = doc.splitTextToSize(
				'Daca doriti detalii si/sau doriti sa continuam demersul realizarii constructiei, va rugam sa ne contactati la numarul de telefon si/sau pe emailul de mai jos.',
				180
			);
			doc.text(splitTextContact, 10, space);
			const emailTextWidth = doc.getTextWidth('Email: ');
			const phoneTextWidth = doc.getTextWidth('Telefon: ');
			doc.setFontStyle("normal");
			doc.text('Email: ', 10, space + 10)
			doc.text('Telefon: ', 10, space + 16)
			doc.setFontSize(10)
			doc.setFontStyle("bold");
			doc.text('contact@vivalanda.ro', 10 + emailTextWidth, space + 10)
			doc.text('0755 661 274', 10 + phoneTextWidth, space + 16)

			doc.text("Continuare pe pagina urmatoare", 10, 280);
			doc.addPage();
			space = 10;

			// Add Images
			doc.addImage(bricksData.img, "JPG", 10, space, 190, 53, "", "FAST");
			space = space + 70

			let description1 = '• Principalul avantaj al boltarilor Star Stone consta in aspectul lor estetic si in varietatea de modele si culori disponibile.';
			let description2 = '• Acestia sunt proiectati pentru a imita aspectul pietrei naturale oferind totusi avantajele unei instalare mai rapide si mai usor de intretinut.'
			let description3 = '• Boltarii Star Stone sunt realizati dintr-un amestec de ciment si agregate, iar suprafata lor poate fi finisata intr-o variatele de texturi pentru a se potrivi cu diferite stiluri de design peisagistic.'
			let description4 = 'Vino si descopera toate optiunile pe care le avem la dispozitie atat in materie de boltari prefabricati cat si in materie de garduri si porti din aluminiu.'
			const splitTextDescription2 = doc.splitTextToSize(description2, 170);
			const splitTextDescription3 = doc.splitTextToSize(description3, 170);
			const splitTextDescription4 = doc.splitTextToSize(description4, 166);

			doc.setFontSize(11);
			doc.setTextColor(100);
			doc.setFontStyle("bold");
			doc.text('BOLTARI PREFABRICATI - STAR STONE', 105, space, {
				align: 'center',
			})

			doc.setFontSize(10);
			doc.setFontStyle("normal");
			doc.text(description1, 10, space + 10)
			doc.text(splitTextDescription2, 10, space + 17, {
				lineHeightFactor: 1.6,
			})
			doc.text(splitTextDescription3, 10, space + 29, {
				lineHeightFactor: 1.6,
			})

			space = space + 50
			doc.setFontSize(10);
			doc.setFontStyle("bold");
			doc.text(splitTextDescription4, 10, space, {
				lineHeightFactor: 1.6,
			})

			space = space + 15
			const addressText = 'Te asteptam la showroomul nostru din: '
			const addressTextWidth = doc.getTextWidth(addressText);
			const address = 'București, Șoseaua Chitilei nr. 176.'
			doc.setFontStyle("normal");
			doc.text(addressText, 10, space);
			doc.setFontStyle("bold");
			doc.text(address, addressTextWidth + 10, space);
			space = space + 20
			doc.addImage(bricksData.imgShowroom, "JPG", 10, space, 190, 53, "", "FAST");


			console.log("GENERATED BRICKS OFFER");
			return doc;
		},
		downloadBricksOffer() {
			this.pdfBricksDoc.save('oferta_boltari_gard.pdf');
		},
		sendBricksNotification() {
			const file = btoa(this.pdfBricksDoc.output());

			let link = process.env.VUE_APP_RO_HUB_API_HOST + "email/partner/configurator_notification_construction";
			let authKey = process.env.VUE_APP_RO_HUB_API_KEY;

			const headers = {
				headers: {
					x_api_key: authKey
				}
			}

			axios
				.post(
					link,
					{
						data: file,
						id_oferta: this.noBricksOffer ? this.noBricksOffer : "00",
						client_name: this.client.name,
						client_surname: this.client.surname,
						client_mail: this.client.email,
						client_phone: this.client.phone,
						client_judet: this.client.judet.value,
					},
					headers
				)
				.then((response) => {
					if (response.data.includes("SENT")) {
						console.log("Notification Bricks SENT");
					} else {
						console.log(response.data);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		async saveCallback() {
			this.$refs.comandaComponent.loadingCallback = true;
			let baseUrl = process.env.VUE_APP_RO_HUB_API_HOST
			let path = "api/fence/inquiries/updateclient"

			const url = baseUrl + path;

			console.log(this.nrOferta)

			await axios.put(url, {
				id: this.nrOferta,
				client_obj: JSON.stringify(this.client),
			})
				.then((response) => {
					console.log(response.data)
					this.completedCallback = true
					this.$refs.comandaComponent.loadingCallback = false;
				})
				.catch((error) => {
					this.$refs.comandaComponent.loadingCallback = false;
					console.error(error);
				});
		},
		getCountyPrice(county) {
			const countyPrice = this.prices.find(priceObj => (priceObj.county == county && priceObj.model == this.model))
			return countyPrice
		},
		async getPrices() {
			await axios
				.get(process.env.VUE_APP_RO_HUB_API_HOST + "api/garduri/preturi-configurator/" + this.country)
				.then((response) => {
					this.prices = response.data;
					console.log(this.prices)
				})
				.catch((error) => {
					console.error(error);
				});
		}
	},
	async created() {
		const searchParams = new URLSearchParams(window.location.search);
		const urlTrackedKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid', 'ttclid', 'msclkid'];
		urlTrackedKeys.forEach(key => {
			if (searchParams.has(key)) this.utmParams[key] = searchParams.get(key);
		});
		if (['ro', 'at', 'de', 'hu', 'fr', 'be'].includes(this.country)) {
			await this.getPrices()
		}
	},
	mounted() {
		this.scroll();
	},
};
</script>

<style lang="css">
.main-page {
	height: 100vh;
	min-height: 100vh;
	overflow: hidden;
	padding-top: 64px;
	padding-bottom: 64px;
}

.mobile-space {
	width: 100%;
	height: 15vh;
}

.v-stepper__step__step .v-icon.v-icon {
	color: #fff;
}

.theme--light.v-card.v-card--outlined.selected {
	border: 1px solid #2196f3;
}

.theme--light.v-chip {
	border: 2px solid transparent;
}

.theme--light.v-chip.selected {
	border: 2px solid #2196f3;
}

.theme--light.v-chip.color-chip {
	border: 2px solid transparent !important;
	box-shadow: 0 0 0 3px transparent;
}

.theme--light.v-chip.color-chip.selected {
	border: 2px solid #ffffff !important;
	box-shadow: 0 0 0 3px #2196f3;
}

.theme--light.v-chip.color-chip.dark span {
	color: #000;
}

header .v-toolbar__content {
	width: 100%;
}

.v-text-field.v-input--dense .v-input__prepend-inner .v-input__icon>.v-icon,
.v-text-field.v-input--dense .v-input__append-inner .v-input__icon>.v-icon {
	margin-top: 4px;
}

.v-card>.v-icon.v-icon.selected {
	position: absolute;
	top: 10px;
	right: 10px;
	color: #2196f3;
	z-index: 10;
}

.pointer {
	cursor: pointer;
}

.white-ripple {
	color: #fff !important;
}

.scroll-container {
	height: 70vh;
	overflow-x: hidden;
}
</style>
